import { LayoutList } from "lucide-react"
import { SectionCard } from "@/components/ui/SectionCard"
import type { TransferPropertyInfoSectionProps } from "./propertyInfoSectionTypes"

export function TransferCompanyPropertyListSection({ ctx }: TransferPropertyInfoSectionProps) {
  const { allProperty } = ctx

  return (
            <SectionCard
              icon={LayoutList}
              title="Property List"
              testId="transfer-process-company-property-list-section"
              titleTestId="transfer-process-company-property-list-title"
            >
              <div
                data-testid="transfer-process-company-property-list-container"
                className="max-h-64 overflow-auto rounded-lg border border-slate-200"
              >
                <table
                  data-testid="transfer-process-company-property-list-table"
                  className="min-w-full text-left text-xs"
                >
                  <thead
                    data-testid="transfer-process-company-property-list-thead"
                    className="bg-slate-100"
                  >
                    <tr>
                      <th
                        data-testid="transfer-process-company-property-list-col-name"
                        className="px-3 py-2 font-semibold text-slate-700"
                      >
                        Property Name
                      </th>
                      <th
                        data-testid="transfer-process-company-property-list-col-address"
                        className="px-3 py-2 font-semibold text-slate-700"
                      >
                        Property Address
                      </th>
                      <th
                        data-testid="transfer-process-company-property-list-col-city"
                        className="px-3 py-2 font-semibold text-slate-700"
                      >
                        Property City
                      </th>
                      <th
                        data-testid="transfer-process-company-property-list-col-state"
                        className="px-3 py-2 font-semibold text-slate-700"
                      >
                        Property State
                      </th>
                      <th
                        data-testid="transfer-process-company-property-list-col-zip"
                        className="px-3 py-2 font-semibold text-slate-700"
                      >
                        Property Zipcode
                      </th>
                      <th
                        data-testid="transfer-process-company-property-list-col-active"
                        className="px-3 py-2 font-semibold text-slate-700"
                      >
                        Active
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {allProperty.map((p) => (
                      <tr
                        key={String(p.property_id)}
                        data-testid={`transfer-process-company-property-row-${String(p.property_id)}`}
                        className="border-t border-slate-100"
                      >
                        <td className="px-3 py-2 text-slate-800">{String(p.property_name)}</td>
                        <td className="px-3 py-2 text-slate-800">{String(p.property_address)}</td>
                        <td className="px-3 py-2 text-slate-800">{String(p.property_city ?? "")}</td>
                        <td className="px-3 py-2 text-slate-800">{String(p.property_state ?? "")}</td>
                        <td className="px-3 py-2 text-slate-800">{String(p.property_zipcode ?? "")}</td>
                        <td className="px-3 py-2 text-slate-800">{p.listed === "1" || p.listed === 1 ? "Yes" : "No"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </SectionCard>
  )
}
